module.exports = __webpack_public_path__ + "assets/img/crayon6.d9812a24.png";